import { render } from "./BookRemove.vue?vue&type=template&id=aeb97ca4"
import script from "./BookRemove.vue?vue&type=script&lang=js"
export * from "./BookRemove.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__